








import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component
export default class ReasonPhraseBadge extends Vue {
  @Prop()
  statusCode!: number;

  @Prop()
  reasonPhrase!: string;

  get statusCodeClass(): string {
    if (this.statusCode) {
      return `badge badge--${this.statusCode}`;
    }

    return `badge`;
  }
}
